import { ActionTypes } from './action';
import { SelectedQuestionDetailsState, AddQuestionsActionsName } from './types';

const selectedQuestionDetailsInitialState: SelectedQuestionDetailsState = {
    textContent: null,
    objectType: null,
    title: null,
    questionContentItemId: null,
    stimulusContentRevisionId: null,
    savedLayout: null,
};

export const SelectedQuestionDetailsReducer = (
    state = selectedQuestionDetailsInitialState,
    action: ActionTypes
): SelectedQuestionDetailsState => {
    switch (action.type) {
    case AddQuestionsActionsName.FETCH_QUESTION_DETAILS:
        return {
            ...state,
            textContent: null,
        };
    case AddQuestionsActionsName.SET_SELECTED_QUESTION_DETAILS:
        return {
            ...state,
            textContent: action.textContent,
            objectType: action.objectType,
            title: action.title,
            questionContentItemId: action.questionContentItemId,
            stimulusContentRevisionId: action.stimulusContentRevisionId,
        };
    case AddQuestionsActionsName.SET_SAVED_LAYOUT:
        return {
            ...state,
            savedLayout: action.savedLayout,
        };
    case AddQuestionsActionsName.CLEAR_QUESTION_DEATILS:
        return selectedQuestionDetailsInitialState;
    default:
        return state;
    }
};
